// @flow
import NumberFormat from 'react-number-format';

type PropsType = {
  value: number | string,
  decimalScale?: number
};

export default function FormattedPrice (props: PropsType) {
  return (
    <NumberFormat
      value={Number(props.value).toFixed(props.decimalScale)} // force proper rounding
      displayType={'text'}
      thousandSeparator
      prefix={'$'}
    />
  );
}
